/* eslint-disable no-nested-ternary */
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { color, layout, space, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Input } from 'antd';
import Search from 'theme/icons/search';

const Wrapper = styled.div`
  ${layout}
  ${space}
  ${typography}

  position: relative;

  outline: 0;

  .ant-input {
    appearance: none;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    color: ${themeGet('colors.grey_400')};
    font-size: 16px;
    line-height: 1.5715;
    background-color: ${themeGet('colors.white')};
    background-image: none;
    box-shadow: none;
    transition: all 0.3s;
    width: 100%;
    height: 38px;
    border: 2px solid;
    border-color: ${themeGet('colors.primary_100')};
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0 ${themeGet('space.s')}px;
    padding-right: ${({ addonAfter }) =>
      addonAfter ? themeGet('space.l') : themeGet('space.s')}px;

    :hover {
      border-color: ${themeGet('colors.primary_200')};
    }

    :focus {
      border-color: ${themeGet('colors.primary_500')};
    }

    :disabled {
      opacity: 0.5;
    }

    :placeholder-shown {
      text-overflow: ellipsis;
    }
  }

  .ant-input-affix-wrapper,
  .ant-input-group {
    position: relative;
  }

  .ant-input-suffix {
    position: absolute;
    right: ${themeGet('space.s')}px;
    top: 0px;
    bottom: 0px;

    .ant-input-password-icon {
      color: ${themeGet('colors.grey_600')};

      & > svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .ant-input-group-addon {
    position: absolute;
    right: ${themeGet('space.s')}px;
    top: 0px;
    bottom: 0px;
  }
`;

const WrapIcon = styled.div`
  ${color}

  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function SearchInput({ addonAfter, autoComplete, disabled, placeholder, style, value, onChange }) {
  const handleChange = useCallback(
    (e) => {
      const { value: v } = e.target;

      onChange(v);
    },
    [onChange],
  );

  return (
    <Wrapper
      addonAfter={addonAfter}
      fontSize="display"
      lineHeight="display"
      fontWeight="normal"
      {...style}
    >
      <Input
        value={value}
        onChange={handleChange}
        autoComplete={autoComplete}
        placeholder={placeholder}
        disabled={disabled}
      />
      <WrapIcon color="primary_200">
        <Search />
      </WrapIcon>
    </Wrapper>
  );
}

export default SearchInput;
